import TalkBackField from '@shared/components/macro/field/TalkbackField';
import { CommandType } from '@shared/constants/CommandValues';
import { IControlFieldProps } from '@shared/models/components/IControlFieldProps';
import ExpressionControlField from './ExpressionControlField';
import ExternalKeyboardControlField from './ExternalKeyboardControlField';
import HeadControlField from './HeadControlField';
import HotkeysControlField from './HotkeysControlField';
import OtherControlField from './OtherControlField';
import TiltControlField from './TiltControlField';
import VoiceControlField from './VoiceControlField';

interface IControlTypeFieldProps extends IControlFieldProps {
    control: CommandType;
}

interface IRenderMap {
    [key: string]: (props: IControlFieldProps) => JSX.Element;
}

const controlTypeRenderMap: IRenderMap = {
    expression: (props: IControlFieldProps) => <ExpressionControlField {...props} />,
    externalKeyboard: (props: IControlFieldProps) => <ExternalKeyboardControlField {...props} />,
    head: (props: IControlFieldProps) => <HeadControlField {...props} />,
    motion: (props: IControlFieldProps) => <TiltControlField {...props} />,
    spoken: (props: IControlFieldProps) => <TalkBackField {...props} />,
    tilt: (props: IControlFieldProps) => <TiltControlField {...props} />,
    hotkey: (props: IControlFieldProps) => <HotkeysControlField {...props} />,
    voice: (props: IControlFieldProps) => <VoiceControlField {...props} />,
    other: (props: IControlFieldProps) => <OtherControlField {...props} />,
};

export function ControlTypeField({ control, value, onChange, disabled, ...restProps }: IControlTypeFieldProps) {
    const controlTypeComponent = controlTypeRenderMap[control];
    if (controlTypeComponent) {
        const controlProps: IControlFieldProps = {
            value: value,
            onChange: onChange,
            disabled: disabled,
            ...restProps,
        };
        return <>{controlTypeComponent(controlProps)}</>;
    }
    return null;
}
